import React from "react";
import './Skills.css'

const Propskills = () => {
    return (
        <div>
            <h2>Proficiency</h2>
      <div class="container">
      </div>
      <div class="skills-div">
        <div class="skills-card">
          <img
            src="https://cdn4.iconfinder.com/data/icons/logos-3/600/React.js_logo-512.png"
            alt=""
          />
          <h3>React</h3>
        </div>
        <div class="skills-card">
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/b/bf/Front-end-logo-color%402x.png"
            alt=""
          />
          <h3>Frontend</h3>
        </div>
        <div class="skills-card">
          <img
            src="https://raw.githubusercontent.com/Rohan-Shakya/Rohan-Shakya/master/images/next_logo.png"
            alt=""
          />
          <h3>NextJs</h3>
        </div>
        <div class="skills-card">
          <img
            src="https://hackr.io/tutorials/data-structures-algorithms/logo-data-structures-algorithms.svg?ver=1587721467"
            alt=""
          />
          <h3>DSA</h3>
        </div>
        <div class="skills-card">
          <img
            src="https://assets-global.website-files.com/6047a9e35e5dc54ac86ddd90/63018720eab24847b1f88ee2_cc137f7e.png"
            alt=""
          />
          <h3>Flutter</h3>
        </div>
      </div>
      <br></br>
      <br></br>
      <br></br>
      <br></br>  <br></br>
        </div>
    )

}
export default Propskills;
